import { combineReducers } from '@reduxjs/toolkit';
import { reducer as formReducer } from 'redux-form';
import { reducer as studentReducer } from './slices/students';

const rootReducer = combineReducers({
  form: formReducer,
  students: studentReducer
});

export default rootReducer;
